export default "__VITE_ASSET__0a4ffaf1__"